import styled, { css } from "styled-components";

interface AlertMessageStyleProps {
  $color: "colored" | "white";
}

export const AlertMessageBox = styled.div`
  gap: 40px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const AlertMessageTitle = styled.h3<AlertMessageStyleProps>`
  gap: 24px;
  display: flex;
  font-size: 2rem;
  font-weight: 700;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  ${(props) =>
    props.$color === "colored" &&
    css`
      color: ${(props) => props.theme.colors.white100};

      svg {
        path {
          fill: ${(props) => props.theme.colors.white100};
        }
      }
    `}
`;

export const AlertMessageText = styled.p<AlertMessageStyleProps>`
  color: ${(props) => props.theme.colors.black60};
  font-size: 1.4rem;
  text-align: center;
  line-height: 160%;

  span {
    color: ${(props) => props.theme.colors.black80};
    font-weight: 800;
    text-decoration: underline;
  }

  ${(props) =>
    props.$color === "colored" &&
    css`
      color: ${(props) => props.theme.colors.white100};
    `}
`;

export const AlertMessageExtra = styled.div`
  gap: 24px;
  width: 100%;
  color: ${(props) => props.theme.colors.black80};
  display: flex;
  padding: 12px 24px;
  font-size: 1.4rem;
  background: ${(props) => props.theme.colors.inputBg};
  align-items: center;
  border-radius: 6px;
  justify-content: center;

  span {
    gap: 6px;
    color: ${(props) => props.theme.colors.primary100};
    display: flex;
    font-weight: 700;
    align-items: center;
  }
`;
